import clsx from 'clsx';
import Icona from 'components/3cat/ui/Icona';
import __isEmpty from 'lodash/isEmpty';
import { useEffect, useRef, useState } from 'react';
import styles from './dropdown.module.scss';

const Dropdown = (props) => {
    const {
        estil,
        estils,
        className,
        textSelector,
        items,
        updateDropdown,
        ariaLabel = 'Obrir desplegable',
        isBlancIcona = true
    } = props;
    const arrayEstils = estils?.split(' ') || [];
    const [openDropdown, setOpenDropdown] = useState(false);
    const [label, setLabel] = useState(textSelector || items[0].desc || items[0].titol);
    const refDropDown = useRef();
    const refDropper = useRef();

    const stylesDropdown = clsx({
        [styles.wrapper]: true,
        [styles.open]: openDropdown,
        ...arrayEstils.reduce((acc, currentStyle) => {
            acc[styles[currentStyle]] = !__isEmpty(currentStyle);
            return acc;
        }, {}),
        [styles[estil]]: !!estil,
        [className]: !__isEmpty(className)
    });

    const itemsDropdown = () => {
        return items?.map((item, index) => {
            const labelItem = item.desc || item.titol;
            const stylesItem = clsx({
                [styles.item]: true,
                [styles.selected]: label === labelItem
            });
            return (
                <li
                    key={`dropdown-${item.id || labelItem}`}
                    aria-selected={label === labelItem}
                    onClick={() => {
                        updateDropdown(item, index);
                        setLabel(labelItem);
                    }}
                    className={stylesItem}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            updateDropdown(item, index);
                            setLabel(labelItem);
                            setOpenDropdown(false);
                            e.preventDefault();
                        }
                    }}
                    role='option'
                    tabIndex='0'
                >
                    {labelItem}
                </li>
            );
        });
    };

    useEffect(() => {
        if (textSelector) setLabel(textSelector);
    }, [textSelector]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!refDropDown?.current?.contains(event.target)) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside, { passive: true });
        document.addEventListener('touchstart', handleClickOutside, { passive: true });

        return () => {
            document.removeEventListener('mousedown', handleClickOutside, { passive: true });
            document.removeEventListener('touchstart', handleClickOutside, { passive: true });
        };
    }, [refDropDown]);

    useEffect(() => {
        if (openDropdown) {
            refDropper.current.setAttribute('aria-expanded', true);
        } else {
            refDropper.current.setAttribute('aria-expanded', false);
        }
    }, [openDropdown]);

    return (
        <div className={stylesDropdown} ref={refDropDown}>
            <button onClick={() => setOpenDropdown(!openDropdown)} className={styles.dropdown} aria-label={ariaLabel}>
                <div className={styles.dropdown_text}>{label}</div>
                <Icona
                    className={styles.drowpdown_icona}
                    icona='fletxa_simple_avall'
                    alt='fletxa desplegar'
                    isBlanc={isBlancIcona}
                />
            </button>
            <div className={styles.dropWrapper} ref={refDropper} onClick={() => setOpenDropdown(false)}>
                <ul data-testid='dropdown' role='listbox'>
                    {itemsDropdown()}
                </ul>
            </div>
        </div>
    );
};

export default Dropdown;
